export default __webpack_public_path__ + "static/media/group.78ea0383.svg";